import React from 'react';
import PropTypes from 'prop-types';
import Close from 'react-md-icon/dist/BaselineClose';

import './CloseButton.scss';

//  TODO: Replace this with CloseButton from strata (requires us to update our react version)
const CloseButton = ({ onClick }) => (
  <button className="btn btn-link align-self-center d-flex justify-content-end close" onClick={onClick}>
    <Close role="link" fontSize="24px" color="black" />
  </button>
);


CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/components/CloseButton/CloseButton.jsx